import React from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import styles from './reports.module.scss';

const Report = ({ airport }) => {
  const history = useHistory();
  const handleReview = () => {
    history.push(`/conditions/${airport.code}`);
  };
  return (
    <div className={styles.report}>
      <div className={styles.title} style={{ marginLeft: '32px' }}>
      <FormattedMessage id="airfieldConditionsReport.title" defaultMessage="Airfield Conditions Report" />
      <i role="presentation"
        onClick={handleReview}
        className={`${styles.review} fa-solid fa-arrow-up-right-from-square`}
        style={{ marginLeft: '65px', cursor: 'pointer' }}
        onKeyPress={handleReview}
      />
      </div>
    </div>
  );
};

export default Report;
